var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.defaultValue)?_c('span',{ref:'label'}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }